import { Observable } from 'rxjs';
import type { ComputedRef, Ref } from 'vue';
import { watch } from 'vue';

export function asObservable<T>(
  ref: Ref<T> | ComputedRef<T>,
  options?: { emitCurrent?: boolean }
): Observable<T> {
  return new Observable<T>((observer) => {
    const unwatch = watch(ref, (value) => observer.next(value), { deep: true });

    if (options?.emitCurrent) {
      observer.next(ref.value);
    }

    return () => unwatch();
  });
}
